import { AnyAaaaRecord } from 'dns'
import * as React from 'react'
import { Field } from 'react-final-form'

export type FieldChangesProps = {
  func: any,
  input: any
  value: any
}

const FieldChange = (func: any, input: any, value: any) => {
  func(value)
  input.onChange(value)
}

export default FieldChange